// M3 plain tooltip as a Svelte action. Usage:
//   <button use:tooltip={"long text shown on hover"}>...</button>
// Empty/falsy text disables it. Re-positions on each hover so layout
// changes between hovers don't strand the tooltip.
//
// Style hooks live in app.css under .m3-tooltip / .m3-tooltip-arrow so the
// theme colors track the rest of the app.

let active = null;
let activeNode = null;

function show(node, text) {
  hide();
  if (!text) return;
  const el = document.createElement('div');
  el.className = 'm3-tooltip';
  el.textContent = text;
  el.setAttribute('role', 'tooltip');
  document.body.appendChild(el);

  const r = node.getBoundingClientRect();
  const margin = 8;
  el.style.left = `${Math.min(window.innerWidth - el.offsetWidth - margin, Math.max(margin, r.left + r.width / 2 - el.offsetWidth / 2))}px`;
  // Prefer below; flip above if it would overflow the viewport.
  let top = r.bottom + 8;
  if (top + el.offsetHeight > window.innerHeight - margin) {
    top = r.top - el.offsetHeight - 8;
  }
  el.style.top = `${Math.max(margin, top)}px`;

  active = el;
  activeNode = node;
}

function hide() {
  if (active) {
    active.remove();
    active = null;
    activeNode = null;
  }
}

export function tooltip(node, text) {
  let current = text;
  let showTimer = null;
  function onEnter() {
    if (!current) return;
    clearTimeout(showTimer);
    // 350ms M3 default delay so brief hovers don't pop tooltips.
    showTimer = setTimeout(() => show(node, current), 350);
  }
  function onLeave() {
    clearTimeout(showTimer);
    if (activeNode === node) hide();
  }

  node.addEventListener('mouseenter', onEnter);
  node.addEventListener('mouseleave', onLeave);
  // Hide on focus loss / scroll so it doesn't strand on the page.
  node.addEventListener('blur', onLeave);
  window.addEventListener('scroll', hide, true);

  return {
    update(newText) { current = newText; },
    destroy() {
      node.removeEventListener('mouseenter', onEnter);
      node.removeEventListener('mouseleave', onLeave);
      node.removeEventListener('blur', onLeave);
      window.removeEventListener('scroll', hide, true);
      clearTimeout(showTimer);
      if (activeNode === node) hide();
    },
  };
}
